const TOKENKEY='token_key'
const getToken=()=>{
    return JSON.parse(localStorage.getItem(TOKENKEY))
}
const setToken=(token)=>{
    return localStorage.setItem(TOKENKEY,JSON.stringify(token))
}
const removeToken=()=>{
    return localStorage.removeItem(TOKENKEY)
}
export{
    getToken,
    setToken,
    removeToken
}